module.exports = __webpack_public_path__ + "img/1kby44DTRuNoPyVlLopG9y6BhY7eQ2SkV.0043c3ef.png";